import { Component } from '@angular/core';
import { HeaderComponent } from '../header/header.component';

@Component({
  selector: 'app-help',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.css'],
  imports: [HeaderComponent],
  standalone: true,
})
export class HelpComponent {
  constructor() {}

}
